import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowRight, Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { COMING } from "@/lib/content";
import { http, errText } from "@/lib/api";

const Waitlist = () => {
  const [email, setEmail] = useState("");
  const [interest, setInterest] = useState("All offerings");
  const [state, setState] = useState("idle");
  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try {
      await http.post("/waitlist", { email, interest });
      setState("done");
    } catch (err) { toast.error(errText(err)); setState("idle"); }
  };
  if (state === "done") return <p data-testid="waitlist-success" className="flex items-center gap-3 text-[#2D2A26] font-display text-2xl"><Check className="text-[#7A8B7B]" /> You're on the list. We'll be in touch.</p>;
  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 w-full">
      <select data-testid="waitlist-interest-select" value={interest} onChange={(e) => setInterest(e.target.value)} className="rounded-full border border-[#D9D1C2] bg-[#FBFBF8] px-5 py-4 text-sm text-[#2D2A26] outline-none focus:border-[#A8613C]">
        <option>All offerings</option>
        {COMING.map((c) => <option key={c.id}>{c.name}</option>)}
      </select>
      <input data-testid="waitlist-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
        className="flex-1 rounded-full border border-[#D9D1C2] bg-[#FBFBF8] px-6 py-4 text-sm text-[#2D2A26] outline-none focus:border-[#A8613C] placeholder:text-[#8A8377]" />
      <button data-testid="waitlist-submit-btn" disabled={state === "busy"} className="btn-pill bg-[#A8613C] text-white hover:bg-[#2D2A26] px-7 py-4 text-sm justify-center">
        {state === "busy" ? <Loader2 size={16} className="animate-spin" /> : <>Join waitlist <ArrowRight size={16} /></>}
      </button>
    </form>
  );
};

export const ComingSoon = () => (
  <section id="coming-soon" className="py-24 sm:py-36">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-8 mb-16">
        <Reveal className="lg:col-span-4"><Overline>Unfolding over the next two years</Overline></Reveal>
        <Reveal delay={0.1} className="lg:col-span-8"><h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2A26]">More of Shaya is on its way.</h2></Reveal>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {COMING.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.08} className="group relative rounded-[28px] border border-dashed border-[#C9B9A3] p-8 min-h-[300px] flex flex-col justify-between hover:bg-[#F4F0E8] transition-colors duration-500">
            <div data-testid={`coming-soon-${c.id}`} className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-[0.25em] text-[#6E685F]">Coming soon</span>
              <span className="w-10 h-10 rounded-full border border-[#C9B9A3] grid place-items-center font-display text-lg text-[#A8613C] transition-transform duration-700 group-hover:rotate-[360deg]">{i + 3}</span>
            </div>
            <div>
              <h3 className="font-display text-4xl text-[#2D2A26]">{c.name}</h3>
              <p className="mt-3 text-sm text-[#5E584F] leading-relaxed">{c.text}</p>
              <div className="mt-5 flex gap-2">{c.tags.map((t) => <span key={t} className="text-xs rounded-full bg-[#EBF0EC] text-[#4F5F50] px-3 py-1">{t}</span>)}</div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 rounded-[32px] bg-[#F4F0E8] p-8 sm:p-12 grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-4">
          <h3 className="font-display text-3xl sm:text-4xl text-[#2D2A26]">Be first to know.</h3>
          <p className="mt-2 text-sm text-[#5E584F]">One gentle email when a new offering opens. Nothing more.</p>
        </div>
        <div className="lg:col-span-8"><Waitlist /></div>
      </Reveal>
    </div>
  </section>
);
